<template>
    <div class="bg-white rounded-[15px] sm:col-span-2 col-span-4 md:col-span-1 xl:col-span-2 overflow-hidden pb-5 order-3 xl:order-1">
        <div class="border-b border-[#eeeff2] py-3 px-5">
            <div class="flex items-center gap-5">
                <span class="block text-[25px] font-[CircularBold] text-center">Activity History</span>
            </div>
        </div>
        <div class="relative overflow-x-auto">
            <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 price-table whitespace-nowrap">
                <thead>
                <tr class="text-[#2a395a] text-[12px] font-[CircularBook] tracking-wider border-b border-[#eeeff2]">
                    <th scope="col" class="ps-5 !pt-2.5 pb-2.5">
                        <button class="flex items-center w-full gap-2.5">
                            <span>Date</span>
<!--                            <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                        </button>
                    </th>
                    <th scope="col" class="px-2 !pt-2.5 pb-2.5">
                        <button class="flex items-center w-full gap-2.5">
                            <span>IP Address</span>
<!--                            <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                        </button>
                    </th>
                    <th scope="col" class="px-2 !pt-2.5 pb-2.5">
                        <button class="flex items-center w-full gap-2.5">
                            <span>Browser</span>
<!--                            <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                        </button>
                    </th>
                </tr>
                </thead>
                <tbody class="text-[12px] font-[CircularMedium] text-[#2a395a]">
                <tr v-if="loading === true">
                    <td colspan="3"><Loading /></td>
                </tr>
                <tr class="bg-white" v-for="activity in activities">
                    <td class="ps-5 pe-2 py-[0] text-left">
                        {{ computedTimezoneDate(activity.created_at) }}
                    </td>
                    <td class="px-2 py-1">
                        {{ activity.causer_ip }}
                    </td>

                    <td class="px-2 py-1">
                        {{ activity.description }}
                    </td>
                </tr>
                </tbody>
            </table>
            <ul class="pagination justify-content-center p-4">
                <li class="page-item bg-[#f3f4f9] m-[2.5px] rounded-lg" :class="{ 'disabled': !prevLink }">
                    <a class="page-link" href="#" @click.prevent="fetchActivity(prevLink)">Previous</a>
                </li>
                <li class="page-item bg-[#f3f4f9] m-[2.5px] rounded-lg" :class="{ 'disabled': !nextLink }">
                    <a class="page-link" href="#" @click.prevent="fetchActivity(nextLink)">Next</a>
                </li>
            </ul>
        </div>
    </div>
</template>


<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import moment from "moment";
import Loading from "../Loading.vue";
const activities = ref({})
const prevLink = ref()
const nextLink = ref()
const loading = ref(true)

const computedTimezoneDate = (date) => {
    return moment(date).format("YYYY-MM-DD HH:mm:ss")
}

onMounted(() => {
    fetchActivity()
})

const fetchActivity = (link = null) => {
    axios.get(link || "/account/activity").then(({ data: { data } }) => {
        loading.value = false
        activities.value = data.data
        prevLink.value = data.prev_page_url
        nextLink.value = data.next_page_url
    }).catch(({ response: {data} }) => {
        toastIt("error", "Error!")
    });
}

</script>
